import React from "react";
import styled from "styled-components";

const ImageBlock = () => {
  return (
    <Wrapper>
      <MainImage src="/images/loginScreen/login bg image.png" />
    </Wrapper>
  );
};

export default ImageBlock;

const MainImage = styled.img`
  width: 100%;
  height: 120vh;
  @media (min-width: 1600px) {
    min-height: 100vh;
    min-width: 100%;
  }
`;
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 100vh;
  overflow: hidden;
  width: 71.5vw;
  @media (max-width: 1024px) {
    width: 61.5vw;
    @media (max-width: 768px) {
      width: 51.5vw;
      @media (max-width: 480px) {
        display: none;
      }
    }
  }
`;
